import React from 'react'
import { getIn } from "formik";
import { errorMessageClasses } from '../common/formInputClasses';

const ErrorMessage = ({ form: { errors, touched }, field }) => (
  <div className={errorMessageClasses}>
    <p>{getIn(errors, field.name) && getIn(touched, field.name) && getIn(errors, field.name)}</p>
  </div>
);

export default ErrorMessage;
